<template>
    <div class="sa-tab-scroll p-3">
        <!-- <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <span class="sa-label-data">Struttura</span>
                <b-form-select v-model="jsonData.codiceStruttura" :options="struttureOptions" value-field="value"
                    text-field="text">
                    <template #first>
                        <b-form-select-option value="TUTTE">TUTTE LE STRUTTURE</b-form-select-option>
                    </template>
</b-form-select>
</b-col>
</b-row> -->

        <b-row class="mt-3">
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <span class="sa-label-data">Nome *</span>
                <b-form-input v-model="jsonData.nome" class="upper" placeholder="Nome Tipologia Visita"></b-form-input>
            </b-col>

            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <span class="sa-label-data">Descrizione</span>
                <b-form-input v-model="jsonData.descrizione" class="upper"
                    placeholder="Descrizione Tipologia Visita"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <span class="sa-label-data">Colore </span>
                <b-input-group size="sm">
                    <b-input-group-prepend>
                        <b-form-input v-model="jsonData.color" type="color"
                            style="width: 50px; height: 38px; padding: 2px; cursor: pointer; border-radius: 8px 0 0 8px;"></b-form-input>
                    </b-input-group-prepend>
                    <b-form-input v-model="jsonData.color" placeholder="#000000"
                        style="border-radius: 0 8px 8px 0;"></b-form-input>
                </b-input-group>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <span class="sa-label-data">Icona/Emoji </span>
                <b-form-input v-model="jsonData.icon"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="12" xl="12">
                <span class="sa-label-data">Note</span>
                <b-form-input v-model="jsonData.note" placeholder="Note Interne"></b-form-input>
            </b-col>


        </b-row>

    </div>
</template>

<script>
import UtilityMixin from '../../../utility/UtilityMixin';
import toast from '../../../../template/layout/utility/sa-toast';

export default {
    mixins: [UtilityMixin],
    name: "AgendaTipologieVisitaEditComponent",
    data() {
        return {
            pathResource: "/agendaappuntamentistati",
            loading: false,
            jsonData: {
                id: null,
                nome: null,
                descrizione: null,
                note: null,
            },
            struttureOptions: []
        };
    },
    methods: {
        init(jsonData) {
            let me = this;
            if (!jsonData || jsonData.id === "-1") {
                me.jsonData = {
                    id: null,
                    nome: null,
                    descrizione: null,
                    note: null,
                };
            } else {
                me.jsonData = { ...jsonData };
            }

            me.loadDataUtentiPresidio();
        },
        getJsonData() {
            return this.jsonData;
        },


        loadDataUtentiPresidio() {
            let me = this;
            let utente = JSON.parse(sessionStorage.getItem("user"));
            UtilityMixin.methods.loadDataResources(
                "/utentipresidi",
                { idUtente: utente.id },
                me.loadDataUtentiPresidiSuccess,
                me.loadDataUtentiPresidiError
            );
        },

        loadDataUtentiPresidiSuccess(response) {
            const uniqueMap = new Map();
            if (response && response.data && response.data.data && response.data.data.list) {
                response.data.data.list.forEach((item) => {
                    if (!uniqueMap.has(item.codiceStruttura)) {
                        uniqueMap.set(item.codiceStruttura, {
                            value: item.codiceStruttura,
                            text: item.denominazioneStruttura
                        });
                    }
                });
            }
            this.struttureOptions = Array.from(uniqueMap.values());
        },

        loadDataUtentiPresidiError(error) {
            console.error("Errore nel recupero presidi:", error);
            toast.error("Errore durante il caricamento dei presidi dell'utente");
        },
    }
};
</script>